export default {
      id: "http-ssl-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "img/icons.svg#http-ssl",
      toString: function () {
        return this.url;
      }
    }